// extracted by mini-css-extract-plugin
export default {"createBtn":"TariffList_createBtn__BZr+K","importBtn":"TariffList_importBtn__KdT82"};